import { useUser } from "hooks/users";
import { trans } from "src/translations";

import styles from "./Author.scss";

const UNKNOWN_USER = "Unknown user";

export const Author = ({ id }) => {
  const { data, isLoading, isError } = useUser(id);
  const user = data?.results;

  return (
    <div className={styles.changedBy}>
      {isLoading && trans.LOADING()}
      {isError && trans.APP_MANIFESTS_CHANGELOG_AUTHOR_ERROR()}
      {trans.APP_MANIFESTS_CHANGELOG_AUTHOR({
        user: user ? `${user.given_name} ${user.family_name}` : UNKNOWN_USER,
      })}
    </div>
  );
};
